import animate from '@play-co/timestep-core/lib/animate';
import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import ImageView from '@play-co/timestep-core/lib/ui/ImageView';
import { downscale } from 'src/conf/scale';

/**
 * Show animated tutorial pointer
 */
export class TutorialPointer extends View {
  private img: ImageView;
  private slideX: number = 0;
  private slideY: number = 0;

  constructor(
    opts: ViewOpts & {
      slideX?: number;
      slideY?: number;
    },
  ) {
    super({
      centerAnchor: true,
      visible: false,
      opacity: 0,
      scale: 0,
      zIndex: 9000,
      canHandleEvents: false,
      blockEvents: true,
      ...opts,
    });

    this.slideX = opts.slideX || 0;
    this.slideY = opts.slideY || 0;

    const width = 96;
    const height = 80;

    this.img = new ImageView({
      superview: this,
      width,
      height,
      image: 'assets/tutorial/hand/tutorial_hand.png',
      centerOnOrigin: true,
    });
  }

  /**
   * Animation loop
   */
  private updateNormal() {
    this.img.updateOpts({ x: 0, y: 30 });
    animate(this.img)
      .now({ x: 0, y: 0 }, 500, animate.easeOut)
      .then({ x: 0, y: 30 }, 500, animate.easeIn)
      .then(() => this.updateNormal());
  }

  private updateSlide() {
    this.img.updateOpts({ x: 100, y: 100, scale: 2, opacity: 0 });
    animate(this.img)
      .now({ x: 0, y: 0, scale: 1, opacity: 1 }, 500, animate.easeOut)
      .then({ x: this.slideX, y: this.slideY }, 600, animate.easeInOut)
      .then(
        { x: this.slideX + 100, y: this.slideY + 100, scale: 2, opacity: 0 },
        300,
        animate.easeIn,
      )
      .then({ x: 100, y: 100 }, 300, animate.easeOut)
      .then(() => this.updateSlide());
  }

  /**
   * Show pointer
   */
  public async fadeIn() {
    animate(this.img).clear();

    this.updateOpts({
      centerOnOrigin: false,
      visible: true,
    });

    if (this.slideX || this.slideY) {
      this.updateSlide();
    } else {
      this.updateNormal();
    }

    return animate(this)
      .clear()
      .then({ opacity: 1, scale: 1 }, 300, animate.easeOut)
      .toPromise();
  }

  /**
   * Hide pointer
   */
  public async fadeOut() {
    await animate(this).clear().toPromise();
    await animate(this.img).clear().toPromise();
    this.updateOpts({ visible: false, opacity: 0, scale: 0 });
  }
}
